var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H8.8C7.11984 21 6.27976 21 5.63803 20.673C5.07354 20.3854 4.6146 19.9265 4.32698 19.362C4 18.7202 4 17.8802 4 16.2V8M4.1 3H20.9C21.4601 3 21.7401 3 21.954 3.10899C22.1422 3.20487 22.2951 3.35785 22.391 3.54601C22.5 3.75992 22.5 4.03995 22.5 4.6V6.4C22.5 6.96005 22.5 7.24008 22.391 7.45399C22.2951 7.64215 22.1422 7.79513 21.954 7.89101C21.7401 8 21.4601 8 20.9 8H4.1C3.53995 8 3.25992 8 3.04601 7.89101C2.85785 7.79513 2.70487 7.64215 2.60899 7.45399C2.5 7.24008 2.5 6.96005 2.5 6.4V4.6C2.5 4.03995 2.5 3.75992 2.60899 3.54601C2.70487 3.35785 2.85785 3.20487 3.04601 3.10899C3.25992 3 3.53995 3 4.1 3ZM10.1 11.5H14.9C15.4601 11.5 15.7401 11.5 15.954 11.609C16.1422 11.7049 16.2951 11.8578 16.391 12.046C16.5 12.2599 16.5 12.5399 16.5 13.1V13.9C16.5 14.4601 16.5 14.7401 16.391 14.954C16.2951 15.1422 16.1422 15.2951 15.954 15.391C15.7401 15.5 15.4601 15.5 14.9 15.5H10.1C9.53995 15.5 9.25992 15.5 9.04601 15.391C8.85785 15.2951 8.70487 15.1422 8.60899 14.954C8.5 14.7401 8.5 14.4601 8.5 13.9V13.1C8.5 12.5399 8.5 12.2599 8.60899 12.046C8.70487 11.8578 8.85785 11.7049 9.04601 11.609C9.25992 11.5 9.53995 11.5 10.1 11.5Z",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArchive);
export default __webpack_public_path__ + "static/media/ic-archive.4d5f6383302f4f33d75f0fa168232a76.svg";
export { ForwardRef as ReactComponent };